import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { withStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import ScoresTable from './ScoresTable';
import ScoresList from './ScoresList';
import PageTitle from '../Common/PageTitle';

const jss = (theme: Theme) => createStyles({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
});

interface Props extends RouteComponentProps {
    getQuizzes: (params?: Bee.Params) => Promise<any>;
    classes: {
        container: string;
    };
    width: Breakpoint;
}

interface State {
    quizzes: Bee.Quiz[];
}

class ScoresPage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            quizzes: [],
        }
    }

    componentDidMount() {
        this.onMount();
    }

    private onMount = async () => {
        const data = await this.props.getQuizzes({
            index: 'state-startTime',
            state: 'completed',
        });
        if (data) {
            this.setState({ quizzes: data.results });
        }
    }

  	render() {
        const { classes } = this.props;
        return (
            <div className={classes.container}>
                <PageTitle title={'Quiz Scores'} />
                    {isWidthUp('md', this.props.width) ?
                        <ScoresTable quizzes={this.state.quizzes} />
                        :
                        <ScoresList quizzes={this.state.quizzes} />
                    }
            </div>
        );
	}
}

export default withWidth()(withStyles(jss)(ScoresPage));



// WEBPACK FOOTER //
// ./src/components/Score/ScoresPage.tsx